import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // Self-hosted @font-face rules — nothing else imported this
import './i18n/i18n'; // Import i18n configuration
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);